import {
  addMarkCode,
  addMipToken,
  addDataParams,
} from "./modules/settings/post";
import { getChannelParams } from "./core/channel";
import { cr } from "fire-wind-water";
import { $match } from "./template/match";
const wd = window as any;
if (!wd.$s_temp) {
  wd.$s_temp = {};
}

/*
const defer = wd.$sk.$skxhrp.delay();
if (wd.$s_temp.jsonParams) {
  defer.resolve(wd.$s_temp.jsonParams);
}
const wh = wd.$s_temp.watch;
wd.$s_temp.watch = function (c) {
  if (c.type === "jsonParams") {
    defer.resolve(c.data);
  }
  if (wh) {
    wh(c);
  }
};*/

const beforeSend = wd.$.ajaxSetup().beforeSend;
wd.$.ajaxSetup({
  contentType: "text/plain",
  beforeSend: function (xhr, config) {
    if (config.type === "post" || config.type === "POST") {
      try {
        //地址栏参数怎么获取出来
        const requestData = JSON.parse(config.data); // json字符串转对象
        if (cr.isPlainObject(requestData)) {
          config.data = requestData;
          //cr.extend(true, config.data, { browseInfo: browseInfo });
          config = addMarkCode(config);
          config = addMipToken(config);
          config = addDataParams(config);
          config.data = JSON.stringify(config.data);
        }
      } catch (err) {
        const channelParams = getChannelParams();
        let browseInfo = "";
        cr.each(channelParams, function (value, key) {
          browseInfo +=
            "&" +
            encodeURIComponent("browseInfo[" + key + "]") +
            "=" +
            encodeURIComponent(value);
        });
        config.data += browseInfo;
        console.log("skintercept_config.data = ", config.data);
      }
    }
    if (beforeSend) {
      beforeSend(xhr, config);
    }
  },
  success: function (config: any) {
    if (config) {
      if (config.cmd === "template.template.getConfig") {
        $match.replace(config.body.content.configInfo);
      }
    }
    return config;
  },
});
